import React, { useCallback, useEffect, useRef, useState } from 'react';
import SettingPrompt from '../../../../components/SettingPrompt';
import { Box, Layout, Page, PageActions, Toast,Text, BlockStack, Card, SkeletonBodyText } from '@shopify/polaris';
import intl from '../../../../i18n/intl';
import './index.css';
import NavTabs from '../components/NavTabs';
import WalletBox from './components/WalletBox';
import AutoPaymentBox from './components/AutoPaymentBox';
import OthersPaymentBox from './components/OthersPaymentBox';
import _ from 'lodash';
import TopUpButton from '../../OrderFulfillment/components/TopUpButton';
import { reqGetInfoSetting, reqGetNewSubscribeList, reqPostNewSubscribeChange, reqPutSettingPayment } from '../../../../api';
import { store } from '../../../../store';
import { changeBannerData } from '../../../../slice';
import EnoughQuotaModal from "../../ProductSelection/SourcingRequest/component/EnoughQuotaModal";
import PersonalAgentModal from "../../SubscriptionPaid/components/PersonalAgentModal";
import defalutData from "../../SubscriptionPaid/components/subData";
const GeneralClass = ({changeSettingBtnState})=> {
  const shopify = window.shopify;
  // 配置保存按钮
  const [btnSaveState, setBtnSaveState] = useState({
    saveDataLoading: false,
    disabledSaveData: true
  });
  const [walletOpen, setWalletOpen] = useState(false);//打开充值弹窗
   const [initPage,setInitPage] = useState(true);
    // 数据内容
   const [pageData, setPageData] = useState({
    auto_payment_settings:{},
    wallet_money:0,
    paypal:{},
    payoneer:{}
   })

     // 使用 useRef 保存初始数据和初始化状态
   const initialPageData = useRef(null);
   const isInitialized = useRef(false);
   // 使用 ref 保存函数引用（避免重复绑定到 window）
     const saveDataRef = useRef();
     const cancelDataRef = useRef();
   

  //  获取数据
  const getPageData = async () => {
    try {
      let res = await reqGetInfoSetting({type:'payment'})
      if (res.code === '200') {
        setPageData(res.data);
        
        initialPageData.current = _.cloneDeep(res.data.auto_payment_settings);
      }else {}
      setInitPage(false)
    } catch (error) {
    }
  };
  useEffect(() => {
    window.saveSettings = {saveData:saveData};
    window.cancelSetting = {cancelData:cancelData}
      // eslint-disable-next-line
  }, []);
  const cancelData = () => {
    setPageData((prev)=>({
      ...prev,
      auto_payment_settings:initialPageData.current,
    }))
    changeSettingBtnState(false)
    setBtnSaveState(prev => ({
      ...prev,
      disabledSaveData: true
    }));
  }
  // 保存数据
  const saveData = async () => {
      try {
        setBtnSaveState(prev => ({
          ...prev,
          saveDataLoading: true
        }));
      let userShippingData = pageData?.auto_payment_settings?.userShipping.filter((item,ind)=>item.child.length !== 0)
      const res = await reqPutSettingPayment({
        auto_pay: pageData?.auto_payment_settings?.auto_pay,
        auto_complete: pageData?.auto_payment_settings?.auto_complete,
        userShippingData: JSON.stringify(userShippingData)
      })
      if (res.code === '200' || res.code === 200) {
        // success
        setBtnSaveState(prev => ({
          ...prev,
          disabledSaveData: true,
          saveDataLoading: false
        }));
        initialPageData.current = _.cloneDeep(pageData?.auto_payment_settings);
        setTimeout(() => {
          changeSettingBtnState(false)
        }, 1000);
        toastFun('Saved successfully')
      }else{
         changeSettingBtnState(false)
        store.dispatch(changeBannerData({bannerData:{
          show:true,
          desc:res.msg
        }}));
      }
      } catch (error) {
      }
    }
 // 更新 ref 的当前值（每次函数更新时同步）
  useEffect(() => {
    saveDataRef.current = saveData;
    cancelDataRef.current = cancelData;
  });
    useEffect(() => {
      if (!isInitialized.current) {
        // 组件首次加载时，记录初始数据并标记初始化完成
        getPageData()
       
        isInitialized.current = true;
      } else {
        // 后续数据变动时，比较当前数据与初始数据
        const isDataChanged = !_.isEqual(pageData.auto_payment_settings, initialPageData.current);
        setBtnSaveState(prev => ({
          ...prev,
          disabledSaveData: !isDataChanged
        }));
        if (isDataChanged) {
          window.saveSettings = { saveData: saveDataRef.current };
          window.cancelSetting = { cancelData: cancelDataRef.current };
        }
      }
       // eslint-disable-next-line
    }, [pageData]); // 监听 pageData 的变化
     useEffect(() => { 
        changeSettingBtnState(!btnSaveState.disabledSaveData)
      }, [btnSaveState,changeSettingBtnState]);
    // 组件卸载时清理
    useEffect(() => {
      return () => {
        window.saveSettings = null;
        window.cancelSetting = null;
      };
    }, []);
    // 次数不足
  const [sourcingLimitModal,setSourcingLimitModal] = useState(false)
  const [planShow, setPlanShow] = useState(true);
      const [subList, setSubList] = useState(defalutData.subList); // 套餐列表
      // 积分剩余
      const [userPoints,setUserPoints] = useState({
        userPointsData:{
          available_points:0,
          total_points:0
        },
        userPointsRedeem:{
          open:false,
          id:0,
          isDetail:false,
          is_new:0,
          isPoints:false
        },
      })
      // 高级套餐
      const [premiumData, setPremiumData] = useState({
        open: false,
        agent_list: [],
      });
      const handlePremiumOff = () => {
        setPremiumData((prevValue) => ({
          ...prevValue,
          open: false,
        }));
      };
       const enhancePackageList = (
         list,
         currentPlanId,
         pricingData,
         trialDays,
         agentList,
         firstPurchase,
         isZt,
         glassesLevel
       ) => list.map(item => {
         const priceInfo = pricingData.find(p => p.key === item.id) || {};
         const isCurrentPlan = item.id === currentPlanId;
         const isAnnualPlan = priceInfo?.is_yearly === 1;
         let button = "";
         let disabled = false;
         if (glassesLevel === 1) {// 当前为年套餐页
           if (isAnnualPlan) {
             if (isCurrentPlan) {// 当前为年套餐页、未购买年套餐的
               if (currentPlanId === 0) {
                 // 未付费用户
                 button = "Current Plan";
                 disabled = true;
               } else if (item.id === 0) {
                 button = "Downgrade";
               } else {
                 button = "Current Plan";
                 disabled = true;
               }
             } else if (
               (item.id === 0 && item.id !== currentPlanId) ||
               (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
             ) {
               button = "Downgrade";
             } else if (currentPlanId !== 4 && item.id < currentPlanId) {
               button = "Downgrade";
             } else if (trialDays !== 0 && item.id !== 4) {
               button =  `Start ${trialDays}-day free trial`;
             } else {
               button = "Select Plan";
             }
           } else {
             if (isCurrentPlan) {
               if (currentPlanId === 0) {
                 // 未付费用户
                 button = "Current Plan";
                 disabled = true;
               }else if (item.id === 4 && currentPlanId === 0) {
                 button = "Select Plan";
               } else {
                 button = "Downgrade";
               }
             } else if (
               (item.id === 0 && item.id !== currentPlanId) ||
               (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
             ) {
               if (item.id === 4 && currentPlanId === 0) {
                 button = "Select Plan";
               }else {
                 button = "Downgrade";
               }
             } else if (currentPlanId !== 4 && item.id < currentPlanId) {
               button = "Downgrade";
             } else if (trialDays !== 0 && item.id !== 4) {
               button = `Start ${trialDays}-day free trial`;
             } else {
               if (item.id === 4 && currentPlanId === 0) {
                 button = "Select Plan";
               }else {
                 button = "Downgrade";
               }
             }
             
           }
         }else {
           if (isAnnualPlan) {
             if (isCurrentPlan) {// 当前为年套餐页、未购买年套餐的
               if (currentPlanId === 0) {
                 // 未付费用户
                 button = "Current Plan";
                 disabled = true;
               } else if (item.id === 0) {
                 button = "Downgrade";
               }else if (trialDays !== 0  && item.id !== 4) {
                 button =  `Start ${trialDays}-day free trial`;
               } else {
                 button = "Select Plan";
               }
             } else if (
               (item.id === 0 && item.id !== currentPlanId)
             ) {
               button = "Downgrade";
             } else if (trialDays !== 0 && item.id !== 4) {
               button =  `Start ${trialDays}-day free trial`;
             } else {
               button = "Select Plan";
             }
           } else {
             if (isCurrentPlan) {
               if (currentPlanId === 0) {
                 // 未付费用户
                 button = "Current Plan";
                 disabled = true;
               } else if (item.id === 0) {
                 button = "Downgrade";
               } else {
                 button = "Current Plan";
                 disabled = true;
               }
             } else if (
               (item.id === 0 && item.id !== currentPlanId) ||
               (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
             ) {
               button = "Downgrade";
             } else if (currentPlanId !== 4 && item.id < currentPlanId) {
               button = "Downgrade";
             } else if (trialDays !== 0  && item.id !== 4) {
               button = `Start ${trialDays}-day free trial`;
             } else {
               button = "Select Plan";
             }
             
           }
           
         }
       
         return {
           ...item,
           ...priceInfo,
           first_purchase: firstPurchase,
           is_zt: isZt,
           bill_level: currentPlanId,
           agent: item.id === 5 ? agentList : [],
           button,
           disabled,
           loading:false
         };
       });
     // 获取套餐数据
       const getSubscribeList = async () => {
         try {
           let res = await reqGetNewSubscribeList();
           if (res.code === "200") {
             const {
              level,
               trial_days,
               agent_list,
               first_purchase,
               is_zt,
               glasses_level,
             } = res.data;
             setPremiumData((prevValue) => ({
               ...prevValue,
               agent_list: res.data.agent_list,
             }));
             setPlanShow((glasses_level === 1 ) ? false : true)
             // 处理月套餐
             const enhancedMonth = enhancePackageList(
               subList.month,
               level,
               res.data.package.month,
               trial_days,
               agent_list,
               first_purchase,
               is_zt,
               glasses_level
             );
             // 处理年套餐
             const enhancedYear = enhancePackageList(
               subList.year,
               level,
               res.data.package.year,
               trial_days,
               agent_list,
               first_purchase,
               is_zt,
               glasses_level
             );
     
             setSubList((prev) => ({
               ...prev,
               month: enhancedMonth,
               year: enhancedYear,
             }));
           }
         } catch (error) {}
       };
       // 升降级
       const handleMageUpgrade = async ( 
         id,
         val = '',
         email = "",
         social = "",
         am_id = "",
       )=>{
         try {
           let param = {
             package_id: id,
             email: email,
             social: social,
             am_id: am_id,
             is_yearly:!planShow ? 1 : 0,
           };
           if (val && val !== "") {
             param.remark = val;
           }
         
         let res = await reqPostNewSubscribeChange(param);
         if (res.code === "200") {
          if (res?.data?.id !== "") {
            if (id !== 0) {
              window.top.location.href = res.data.url;
              toastFun(res.msg);
            }
          }
        } else {
          toastFun("Something wrong");
        }
       } catch (error) {
           
       }
       }
       
      const handleSubmit = (val) => {
        if (val) {
            if (val === 5) {
                setPremiumData((prevValue) => ({
                    ...prevValue,
                    open: true,
                  }));
                setSourcingLimitModal(false)
            }
            if (val === 6) {
              setUserPoints((prevValue)=>({
                ...prevValue,
                userPointsRedeem:{
                  ...prevValue.userPointsRedeem,
                  isPoints:true
                }
              }))
              setSourcingLimitModal(false)
              
            }
            if (val <5) {
              handleMageUpgrade(val)
            }
        }
      };
      const handleSoureOff = (value) => {
        setSourcingLimitModal(value);
      };

useEffect(() => {
    let isOp = false;
    if (!isOp) {
      getSubscribeList()
    }
    return () => {
      isOp = true;
    };
   // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [toast, setToast] = useState(false); // 提示
  const [toastError, setToastError] = useState(false);
  const [toastMsg, setToastMsg] = useState("");

  const toggleToast = useCallback(() => setToast((toast) => !toast), []);

  const toastMarkup = toast ? (
    <Toast content={toastMsg} onDismiss={toggleToast} error={toastError} />
  ) : null;

  const toastFun = (msg, error) => {
    setToastError(error);
    setToastMsg(msg);
    setToast(false);
    toggleToast();
  };
  
  const pageContent = (
    <Box>
      <BlockStack gap={500}>
        <Box className='h1_m'>
      <Text variant="headingLg" as="h5">
      Payment
      </Text>
        </Box>
      <BlockStack gap={400}>
      <WalletBox pageData={pageData} setWalletOpen={setWalletOpen}/>
      <AutoPaymentBox auto_payment_settings={pageData?.auto_payment_settings} setPageData={setPageData} setSourcingLimitModal={setSourcingLimitModal}/>
      <OthersPaymentBox pageData={pageData} getPageData={getPageData} setPageData={setPageData}/>
      </BlockStack>
      </BlockStack>
      {walletOpen && <TopUpButton setWalletOpen={setWalletOpen} />}
    </Box>
  )
  const initSkeletonPage = (
    <Box className="skeleton_page">
    <Box className="skeleton_page_children">
    <Layout.Section>
      <Card>
      <BlockStack gap={400}>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      <SkeletonBodyText lines={3}/>
      </BlockStack>
      </Card>
    </Layout.Section>
    </Box>
    </Box>
  )
  return (
    <div className={shopify ? "setting_page_shopify" : "setting_page"}>
      {!shopify && <SettingPrompt disabledSaveData={btnSaveState.disabledSaveData} url='/admin/settings/payment' saveData={saveData} />}
        <Page
          title={shopify ? '' : intl.get("Settings")}
          separator
        >
        <Layout>
        <Layout.Section variant="oneThird">
            <NavTabs selected="Payment" saveData={saveData} loading={btnSaveState.saveDataLoading} disabled={btnSaveState.disabledSaveData}/>
        </Layout.Section>
        <Layout.Section>
         {initPage && initSkeletonPage }
                <Box style={{opacity: initPage ? 0 : 1}}>
                {pageContent}
                </Box>
        </Layout.Section>
        </Layout>
        {/* 次数不够 */}
        <EnoughQuotaModal
              type={"auto_fulfillment"}
              sourceLess={{}}
              planShow={planShow}
              handleSubmit={handleSubmit}
              sourcingLimitModal={sourcingLimitModal}
              userPoints={userPoints}
              subList={subList}
              setSourcingLimitModal={handleSoureOff}
            />
            {/* agent选择 */}
            <PersonalAgentModal
              premiumData={premiumData}
              handlePremiumOff={handlePremiumOff}
              handleMageUpgrade={handleMageUpgrade}
            />
          {toastMarkup}
          {!shopify && <PageActions 
          primaryAction={
            {
              content: intl.get("Save"),
              onAction: saveData,
              loading: btnSaveState.saveDataLoading,
              disabled: btnSaveState.disabledSaveData
            }
          }
          >
            </PageActions>}
        </Page>
    </div>
  );
}

export default GeneralClass;
